import axios from 'axios';
import { toVietnameseMessage } from '../utils/errorMessageVi';

const getApiUrl = () => {
  if (import.meta.env.VITE_API_URL) {
    return import.meta.env.VITE_API_URL;
  }

  // Cloud-first default (single frontend only talks to cloud backend)
  return 'http://localhost:5000/api';
};

const api = axios.create({
  baseURL: getApiUrl(),
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    const hasAuthorizationHeader = Boolean(config?.headers?.Authorization || config?.headers?.authorization);
    if (token && !hasAuthorizationHeader) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const responseMessage = error?.response?.data?.error?.message;
    const directMessage = error?.response?.data?.message;

    if (responseMessage) {
      error.response.data.error.message = toVietnameseMessage(responseMessage);
    }

    if (directMessage) {
      error.response.data.message = toVietnameseMessage(directMessage);
    }

    if (!responseMessage && !directMessage && error?.message) {
      error.message = toVietnameseMessage(error.message);
    }

    if (error.response?.status === 401) {
      const requestUrl = error.config?.url || '';
      const isLoginRequest = requestUrl.includes('/auth/login');

      if (isLoginRequest) {
        return Promise.reject(error);
      }

      localStorage.removeItem('token');
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;


